import { FC } from 'react';
import styled from 'styled-components';

import { useCollapsible } from './useCollapsible/useCollapsible';
import { TOGGLE_ANIMATION_DURATION } from './constants';

const OuterWrapper = styled.div`
  overflow: hidden;
`;

const InnerWrapper = styled.div<{ $isCollapsed: boolean }>`
  transition: ${TOGGLE_ANIMATION_DURATION} opacity ease;
  opacity: ${({ $isCollapsed }) => ($isCollapsed ? '0.0' : '1.0')};
`;

export type CollapsibleContentProps = {
  isCollapsed: boolean;
};

export const CollapsibleContent: FC<React.PropsWithChildren<CollapsibleContentProps>> = ({
  isCollapsed,
  children,
  ...props
}) => {
  const { innerRef, outerRef } = useCollapsible<HTMLDivElement, HTMLDivElement>(
    isCollapsed,
    TOGGLE_ANIMATION_DURATION,
  );

  return (
    <OuterWrapper {...props} ref={outerRef}>
      <InnerWrapper ref={innerRef} $isCollapsed={isCollapsed}>
        <div>{children}</div>
      </InnerWrapper>
    </OuterWrapper>
  );
};
